import { RoofLine } from 'store/slices/RoofToolLinesSlice/types';

const POINT_MATCH_THRESHOLD = 3;

const POINT_SNAP_THRESHOLD = 5;

const POINT_SNAP_THRESHOLD_AFTER_UNMERGE = 3;

const CLICK_ON_LINE_THRESHOLD = 1;

const INVALID_AREA_THRESHOLD = 0.001;

const EDGE_HIT_STROKE = 3;

const EDGE_TYPES = {
	EAVES: 'eaves',
	VALLEYS: 'valleys',
	HIPS: 'hips',
	RIDGES: 'ridges',
	RAKES: 'rakes',
	WALL_FLASHING: 'wallFlashing',
	STEP_FLASHING: 'stepFlashing',
	PRAPET_WALL: 'prapetWall',
	TRANSITION: 'transition',
	NONE: 'none',
} as const;

type EdgeType = typeof EDGE_TYPES[keyof typeof EDGE_TYPES];

const roofLines: Record<string, RoofLine> = {
	[EDGE_TYPES.EAVES]: { name: 'Eaves', color: '#FF53EE', dashed: [] },
	[EDGE_TYPES.VALLEYS]: { name: 'Valleys', color: '#B2FF00', dashed: [] },
	[EDGE_TYPES.HIPS]: { name: 'Hips', color: '#00E0FF', dashed: [] },
	[EDGE_TYPES.RIDGES]: { name: 'Ridges', color: '#7B00FF', dashed: [] },
	[EDGE_TYPES.RAKES]: { name: 'Rakes', color: '#912637', dashed: [] },
	[EDGE_TYPES.WALL_FLASHING]: { name: 'Wall Flashing', color: '#FF3737', dashed: [5, 1] },
	[EDGE_TYPES.STEP_FLASHING]: { name: 'Step Flashing', color: '#3CFFC4', dashed: [5, 3] },
	[EDGE_TYPES.PRAPET_WALL]: { name: 'Prapet Wall', color: '#25A3FF', dashed: [] },
	[EDGE_TYPES.TRANSITION]: { name: 'Transition', color: '#0FD873', dashed: [] },
	[EDGE_TYPES.NONE]: { name: 'none', color: '#6B6D8F', dashed: [] },
};

const specialFacetLines: readonly EdgeType[] = [EDGE_TYPES.EAVES, EDGE_TYPES.RAKES];
const GUTTER_LINE_CONFIG = {color: '#ffc005', strokeWidth: 3, viewStrokeWidth: 5};
const LENGTH_VARYING_EDGE_TYPES: readonly EdgeType[] = [EDGE_TYPES.RAKES, EDGE_TYPES.VALLEYS, EDGE_TYPES.HIPS];

// gutter lines live on the eaves, an untyped edge gets classified as one
// when a gutter is added to it
const GUTTER_EDGE_TYPE = EDGE_TYPES.EAVES;
const INVAILD_FACET_HIGHLIGHT = 'rgba(255,0,0,0.3)';
const EDITED_FACET_HIGHLIGHT_COLOR = 'rgba(0, 128, 255, 0.5)';

export {
	POINT_MATCH_THRESHOLD, POINT_SNAP_THRESHOLD, 
	CLICK_ON_LINE_THRESHOLD, roofLines, POINT_SNAP_THRESHOLD_AFTER_UNMERGE,
	specialFacetLines, GUTTER_LINE_CONFIG, LENGTH_VARYING_EDGE_TYPES,INVAILD_FACET_HIGHLIGHT,
	INVALID_AREA_THRESHOLD, EDITED_FACET_HIGHLIGHT_COLOR, EDGE_HIT_STROKE,
	EDGE_TYPES, GUTTER_EDGE_TYPE
};

export type { EdgeType };
